import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';

import { isLoggedIn, decodedToken } from '../config/token';
import LoginForm from '../components/Login/LoginForm';

/* Reset browser default margin/padding that causes white strips */
const globalReset = `
  html, body, #root {
    margin: 0 !important;
    padding: 0 !important;
    height: 100%;
    overflow-x: hidden;
  }
`;

const Login = () => {
  const { access } = decodedToken;
  const [loginData, setLoginData] = useState({
    isLoggedIn: false,
    redirectPath:
      isLoggedIn() && access && Object.prototype.hasOwnProperty.call(access, 'pmms')
        ? '/home'
        : '/masterlist',
  });

  if (isLoggedIn() || loginData.isLoggedIn)
    return <Redirect to={loginData.redirectPath} />;

  return (
    <>
      <style>{globalReset}</style>
      <LoginForm setLoginData={setLoginData} />
    </>
  );
};

export default Login;